<div class="d-flex justify-content-between generic-row-item py-1" [ngClass]="{'without-sub' : withoutSub}" matRipple style="cursor: not-allowed;">
    <div class="d-flex flex-column text-muted" style="width: 100%; padding-left: 8px;">
        <div>{{data.title}}</div>
        <div *ngIf="!withoutSub" style="font-size: 13px;">{{data.subTitle}}</div>
    </div>
    <div class="row-icon" [hidden]="!data.displayDelete">
        <div class="ic-center">
            <button mat-icon-button disabled color="primary" aria-label="Example icon button with a delete icon">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </div>

    <div style="align-self: center;">
        <!-- <button mat-icon-button disabled>
            <mat-icon>keyboard_arrow_right</mat-icon>
        </button> -->
    </div>
</div>